import {Grid, IconButton, Tooltip, useTheme} from "@mui/material";
import {Item} from "../../../domains/common/components/Item";
import {IndentSpace, Link1, Title5} from "../../../domains/common/components/Typography";
import FormSelect from "../../../domains/common/components/FormSelect";
import {registrationTypesSelect} from "../../../dictionaries";
import {dealData} from "../deal";
import {userOptions} from "../../../user";
import Box from "@mui/material/Box";
import {TextareaCtrl} from "../../../domains/common/components/FormInput";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import React, {useContext, useState} from "react";
import {DealPageContext} from "../index";
import SyncDrawer from "./SyncBatchComponent";

export const DealHeader = () => {
  const {dataHasLoaded, addParamsContainer, changeDealType, title, saveTitle, makeTitle} = useContext(DealPageContext);
  const theme = useTheme();
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (<Grid container spacing={0}>
    <Grid item xs={12}>
      {
        (() => {
          if (dataHasLoaded) {
            return (<Item sx={{pr: "4px", backgroundColor: theme.palette.background.default}}>
              <SyncDrawer
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                currentDealId={dealData.dealId}
                currentDealTitle='ТЕСТ'
              />
              <Grid container spacing={0} wrap="nowrap">
                <Grid item sx={{width: 270, pt: '0px'}}>
                  <Grid container>
                    <Grid item xs={12}>
                      <Title5 title="Регистрационное действие"/>
                    </Grid>
                    <Grid item xs={12}><FormSelect elemId="registrationTypeSelect" name="type"
                                                   data={registrationTypesSelect} minWidth={250}
                                                   disabled={!!dealData.deal?.type}
                                                   onChange={changeDealType} maxWidth={300}
                                                   value={dealData.deal?.type}
                    /></Grid>
                    <Grid item xs={12} sx={{height: 10}}></Grid>
                    <Grid item xs={12}>
                      {dealData.deal?.parentId ?
                        <Link1 target={userOptions.openLinkCurrentTab ? "" : "_blank"}
                               href={`/deal?id=${dealData.deal.parentId}`}>Основная сделка</Link1> : void 0}
                    </Grid>
                    <Grid item xs={12}>
                      <SyncButtonAndCRMLink setDrawerOpen={setDrawerOpen}/>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item sx={{width: 530}}>
                  <Box sx={{width: '100%', overflow: 'auto', paddingTop: '5px'}}>
                    {addParamsContainer}
                  </Box>
                </Grid>
                <Grid item sx={{width: 295}} display="flex" justifyContent="flex-end">
                  <TextareaCtrl label="Описание сделки" className="dealForm" name="title"
                                multiline={true} rows={3} value={title}
                                onChange={saveTitle} maxlenght='128' width="260px"/>

                  <Tooltip title="Добавить ФИО участников в описание" placement="right">
                    <IconButton onClick={makeTitle} style={{backgroundColor: 'transparent'}}
                                sx={{
                                  color: theme.palette.icon.default,
                                  fontSize: '12pt',
                                  pl: '8px',
                                  pr: "0px"
                                }}
                                aria-label="directions">
                      <ArrowBackIosIcon sx={{fontSize: '12pt'}}/>
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
            </Item>)
          }
        })()
      }
    </Grid>
  </Grid>)
};

const SyncButtonAndCRMLink = ({setDrawerOpen}) => {
  if (!dealData.deal.backlink)
    return '';

  const theme = useTheme();

  return (
    <Box sx={{display: 'flex', alignItems: 'center'}}>
      <Link1 target={userOptions.openLinkCurrentTab ? "" : "_blank"}
             href={`${dealData.deal.backlink}`}>Открыть в CRM</Link1> <IndentSpace size={10}/> | <IndentSpace
      size={10}/>
      <Tooltip title="Синхронизировать данные со связанными сделками" placement="right">
        <Link1
          onClick={() => {
            setDrawerOpen(true)
          }}
          sx={{
            cursor: 'pointer',
            textDecoration: 'underline',
            '&:hover': {
              textDecoration: 'underline',
              color: 'primary.main'
            }
          }}
        >Перенести данные</Link1>
      </Tooltip>
    </Box>
  )
}
